import React, { Component, Fragment } from "react";
import { inject } from "mobx-react";
import { Grid, Badge, DialogActions, DialogContent, Button, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";

import { SoloIcon, BandIcon, InvitationIcon, InfoIcon, CheckmarkIcon } from "./WelcomeIcons";

import "./ChooseProfile.css";
import "./CreateAct.css";
import { ProfileRelationType } from "../../types/enum";
import ModalContainer from "../modal/ModalContainer";
import ResponsiveTable from "../table/ResponsiveTable";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import TableRowProfile from "../util/TableRowProfile";
import SimpleSnackbar from "../snackBar/snackbar";
import image from "../../helper/image";

@inject("profileStore", "userStore", "userInvitationStore", "templateStore")
@withRouter
class CreateAct extends Component {
    invitations = [];

    columns = [];

    rows = [];

    constructor(props) {
        super(props);
        this.state = {
            invitationsModalState: false,
            isLoading: true,
            disabled: false
        };

        this.columns = [{ key: "invitee", label: "Invitee" }, { key: "actName", label: "Act Name" }, { key: "action", label: "" }];

        this.rows = [];
    }

    mapInvitations = () => {
        this.rows = [];

        this.invitations.forEach(invitation => {
            let row = {};

            row.invitee = (
                <TableRowProfile
                    profileId = { invitation.createdById }
                    name={invitation.createdBy.fullName}
                    avatarUrl={image.getProfileImage(invitation.createdBy)}
                />
            );
            row.actName = invitation.invitedAct;

            row.action = (
                <Fragment>
                    <Button variant="contained" size="small" color="primary" onClick={() => this.handleAccept(invitation)}>
                        Accept and Create Act
                    </Button>
                    &nbsp;
                    <Button variant="outlined" size="small" onClick={() => this.handleDecline(invitation)}>
                        Decline
                    </Button>
                </Fragment>
            );

            this.rows.push(row);
        });
    };

    componentDidMount = () => {
        this.props.profileStore.getProfileAct().then(profile => {
           if(profile){
                this.props.history.push(`/myact/edit/${profile.id}`);
           }else{
            Promise.all([
                this.props.userInvitationStore.getUserInvitationByEmailAndType(ProfileRelationType.AgentAct.ordinal).then(response => {
                    response.forEach(data => {
                        this.invitations.push(data);
                    });
                }),
                this.props.userInvitationStore.getUserInvitationByEmailAndType(ProfileRelationType.VenueAct.ordinal).then(response => {
                    response.forEach(data => {
                        this.invitations.push(data);
                    });
                })
            ]).then(
                () => {
                    this.setState(
                        {
                            ...this.state,
                            isLoading: false
                        },
                        () => {
                            this.mapInvitations();
                        }
                    );
                },
                err => {
                    this.setState({
                        ...this.state,
                        isLoading: false
                    });
                }
            );
           }
        })
       
    };

    handleOpenInvitationsModal = () => {
        this.setState({ ...this.state, invitationsModalState: true });
    };

    handleCloseInvitationsModal = () => {
        this.setState({ ...this.state, invitationsModalState: false });
    };

    handleCreateAct = e => {
        e.preventDefault();
        this.props.history.replace(`/myact/create`);
    };

    handleCreateSoloAct = e => {
        e.preventDefault();

        this.setState({
            ...this.state,
            isLoading: true,
            disabled: true
        })

        this.props.profileStore.createSoloAct().then(profile => {
            this.props.userStore.completeUser().then(user => {
                this.props.history.push(`/myact/edit/${profile.id}`);
            });
        })
    };



    // handleGoToDashboard = () => {
    //     this.props.userStore.completeUser().then(user => {
    //         this.props.history.push(`/`);
    //     });
    // };

     handleGoToDashboard = e => {
        e.preventDefault();
        const { currentUser } = this.props.userStore;
        const status = currentUser.status;
        this.props.userStore.completeUser().then(user => {
            switch (status) {
                case 1:
                    this.props.history.push("/musician");
                    break;
                case 11:
                    this.props.history.push("/agent");
                    break;
                case 21:
                    this.props.history.push("/staff");
                    break;
                default:
                    this.props.history.push("/account/setting");
                    break;
            }
        });
    };

    handleAccept = invitation => {
        this.setState({
            ...this.state,
            isLoading: true
        });
        this.props.userInvitationStore.acceptUserInvitation(invitation.id).then(response => {
            if (response.newProfileId > 0) {
                this.invitations = this.invitations.filter(x => x.id !== invitation.id);
                this.mapInvitations();

                this.setState({
                    ...this.state,
                    isLoading: false,
                    invitationsModalState: false
                });
                this.props.userStore.completeUser().then(user => {
                    this.props.history.push(`/myact/edit/${response.newProfileId}`);
                });
               
            } else {
                this.invitations = this.invitations.filter(x => x.id !== invitation.id);
                this.mapInvitations();

                this.props.templateStore.openSnackbar("Invitation has been accepted.");

                this.setState({
                    ...this.state,
                    isLoading: false
                });
            }
        });
    };

    handleDecline = invitation => {
        this.setState({
            ...this.state,
            isLoading: true
        });
        this.props.userInvitationStore.declineUserInvitation(invitation.id).then(response => {
            this.invitations = this.invitations.filter(x => x.id !== response.id);
            this.mapInvitations();

            this.props.templateStore.openSnackbar("Invitation has been declined.");

            this.setState({
                ...this.state,
                isLoading: false
            });
        });
    };

    renderWithInvitations() {
        const { invitationsModalState, isLoading } = this.state;
        const invitationCount = this.invitations.length;

        return (
            <Fragment>
                <div className="invitations-view">
                    <div className="progress-badge">
                        <CheckmarkIcon />
                        <span>Personal profile complete - one more step!</span>
                    </div>

                    <h1 className="invitations-heading">You have act invitations!</h1>
                    
                    <p className="invitations-description">
                        A venue or agency has invited you to join their roster. Review your invitations 
                        and create your act to get started.
                    </p>

                    <div className="invitation-card-container">
                        <div className="invitation-card" onClick={this.handleOpenInvitationsModal}>
                            <div className="invitation-icon-wrapper">
                                <InvitationIcon />
                                <span className="invitation-count-badge">{invitationCount}</span>
                            </div>
                            <h3 className="invitation-card-title">View Act Invitations</h3>
                            <p className="invitation-card-subtitle">Accept a roster invitation from a venue or agency</p>
                        </div>
                    </div>

                    <a className="skip-link" onClick={this.handleGoToDashboard}>
                        I'll decide later - take me to the dashboard
                    </a>
                </div>

                <LoadingSpinner showed={isLoading} />
                <SimpleSnackbar />
                <ModalContainer 
                    open={invitationsModalState} 
                    onClose={this.handleCloseInvitationsModal} 
                    title=""
                    className="invitations-modal"
                >
                    <div className="invitations-modal-header">
                        <div className="modal-header-content">
                            <InvitationIcon />
                            <span>Act Invitations</span>
                        </div>
                        <button className="modal-close-btn" onClick={this.handleCloseInvitationsModal}>×</button>
                    </div>
                    <DialogContent className="invitations-modal-content">
                        <p className="modal-intro-text">
                            These venues or agencies want to add your act to their roster. Accept to create your act and join their roster.
                        </p>
                        <div className="invitation-list">
                            {this.invitations.map((invitation, index) => (
                                <div key={index} className="invitation-row">
                                    <div className="invitation-avatar">
                                        {invitation.createdBy?.fullName?.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() || 'IN'}
                                    </div>
                                    <div className="invitation-info">
                                        <div className="invitation-name">{invitation.createdBy?.fullName || 'Unknown'}</div>
                                        <div className="invitation-act-name">{invitation.invitedAct || 'Act Invitation'}</div>
                                    </div>
                                    <div className="invitation-actions">
                                        <Button 
                                            variant="contained" 
                                            size="small" 
                                            className="accept-btn"
                                            onClick={() => this.handleAccept(invitation)}
                                        >
                                            Accept and Create Act
                                        </Button>
                                        <Button 
                                            variant="outlined" 
                                            size="small" 
                                            className="decline-btn"
                                            onClick={() => this.handleDecline(invitation)}
                                        >
                                            Decline
                                        </Button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </DialogContent>
                    <DialogActions className="invitations-modal-footer">
                        <Button onClick={this.handleCloseInvitationsModal}>Close</Button>
                    </DialogActions>
                </ModalContainer>
            </Fragment>
        );
    }

    renderWithoutInvitations() {
        const { isLoading } = this.state;

        return (
            <Fragment>
                <div className="create-act-view">
                    <div className="progress-badge">
                        <CheckmarkIcon />
                        <span>Personal profile complete - one more step!</span>
                    </div>

                    <h1 className="create-act-title">Now let's create your act</h1>
                    <p className="create-act-subtitle">
                        Your personal profile is like your Facebook profile. Your act is like a Facebook page - it's what hirers (agents, venues, private hirers) see, search for, and book.
                    </p>

                    <div className="why-act-box">
                        <strong>Why do I need an act profile?</strong>
                        <p>Hirers search for acts by genre, location, and availability. Without an act profile, you won't appear in searches and can't receive bookings.</p>
                    </div>

                    <div className="act-type-cards">
                        <div className="act-type-card" onClick={this.handleCreateSoloAct}>
                            <div className="act-type-icon">
                                <SoloIcon />
                            </div>
                            <h3 className="act-type-title">Create Solo Act</h3>
                            <p className="act-type-subtitle">Copies your profile info automatically</p>
                        </div>
                        <div className="act-type-card" onClick={this.handleCreateAct}>
                            <div className="act-type-icon">
                                <BandIcon />
                            </div>
                            <h3 className="act-type-title">Create Band / Duo Act</h3>
                            <p className="act-type-subtitle">For groups with multiple members</p>
                        </div>
                    </div>

                    <div className="player-info-box orange">
                        <strong>Already playing in a band?</strong>
                        <p>If you're a player in someone else's act, you may not need to create your own act. Check with your band leader - they can add you as a player to their act.</p>
                    </div>

                    <div className="skip-warning-box">
                        <span className="warning-icon">⚠</span>
                        <span><strong>Skipping this step?</strong> You won't be visible to hirers or receive booking requests until you create an act.</span>
                    </div>

                    <a className="skip-link" onClick={this.handleGoToDashboard}>
                        I'll finish this later
                    </a>
                </div>
                <LoadingSpinner showed={isLoading} />
                <SimpleSnackbar />
            </Fragment>
        );
    }

    render() {
        const hasInvitations = this.invitations.length > 0;

        if (hasInvitations) {
            return this.renderWithInvitations();
        }
        
        return this.renderWithoutInvitations();
    }
}

export default CreateAct;
